(function () {
  'use strict';

  function activateCategory(menu, key) {
    menu.querySelectorAll('[data-kbd-menu-panel]').forEach(function (panel) {
      var active = panel.dataset.kbdMenuPanel === key;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    menu.querySelectorAll('[data-kbd-menu-category]').forEach(function (item) {
      item.classList.toggle('is-preview-active', item.dataset.kbdMenuCategory === key);
    });
  }

  function initLinkedMenu(menu) {
    if (menu.dataset.kbdLinkedReady === 'true') return;
    menu.dataset.kbdLinkedReady = 'true';
    var first = menu.querySelector('[data-kbd-menu-category]');
    if (first) activateCategory(menu, first.dataset.kbdMenuCategory);

    menu.addEventListener('mouseover', function (event) {
      var item = event.target.closest('[data-kbd-menu-category]');
      if (item && menu.contains(item)) activateCategory(menu, item.dataset.kbdMenuCategory);
    });
    menu.addEventListener('focusin', function (event) {
      var item = event.target.closest('[data-kbd-menu-category]');
      if (item && menu.contains(item)) activateCategory(menu, item.dataset.kbdMenuCategory);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kbd-linked-menu]').forEach(initLinkedMenu);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kbd-linked-menu]').forEach(initLinkedMenu);
  });
})();
